/** Customer-facing part number resolver (mirrors backend routers/part_number.py).
 *  The SUNTRONIX internal Product ID (PRD-######, PR#, SRV-, CMP-, LEG-) must
 *  NEVER be shown on any customer-facing quote/composer surface. */
const INTERNAL = /^\s*(PRD-|PRO\d|PR\d|SRV-|CMP-|LEG-)/i;

export const isInternalId = (v) => !!(v && INTERNAL.test(String(v).trim()));

export function customerPartNumber(item, dflt = "—") {
  if (!item) return dflt;
  const cands = [
    item.oem_part_number, item.part_number, item.sku, item.manufacturer_part_number,
  ];
  for (const v of cands) {
    if (v && !isInternalId(v)) return String(v).trim();
  }
  return dflt;
}
